import { Injectable } from '@angular/core';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable, delay, of } from 'rxjs';
import { ClientMonitoring } from '@interfaces/control/monitoring/responses/client-monitoring.response';
import { MonitoringStatusColumn } from '@interfaces/control/monitoring/responses/monitoring-status.response';
import { MonitoringFilterDto } from '@interfaces/control/monitoring/requests/monitoring-filter.request';
import { MOCK_CLIENTS, MOCK_STATUS_COLUMNS } from './monitoring-mock-data';

@Injectable({ providedIn: 'root' })
export class MonitoringHttpService {
  private useMockData = true; // Toggle para dev: true = mock, false = API real

  constructor(private readonly apiService: VaultApiService) {}

  getClients(filters: MonitoringFilterDto): Observable<ClientMonitoring[] | null> {
    if (this.useMockData) {
      // Mock: simular delay de rede e filtrar localmente
      let filteredClients = [...MOCK_CLIENTS];

      if (filters.owner) {
        filteredClients = filteredClients.filter(c => c.owner === filters.owner);
      }

      if (filters.currency && filters.currency !== 'All') {
        // Filtro de currency pode ser implementado no futuro baseado em exposure
      }

      if (filters.contingencyStatus && filters.contingencyStatus.length > 0) {
        filteredClients = filteredClients.filter(c =>
          filters.contingencyStatus!.includes(c.contingencyStatus)
        );
      }

      if (filters.status && filters.status.length > 0) {
        filteredClients = filteredClients.filter(c => filters.status!.includes(c.status));
      }

      if (filters.bandUsageMin !== undefined) {
        filteredClients = filteredClients.filter(c => c.bandUsagePercent >= filters.bandUsageMin!);
      }

      if (filters.bandUsageMax !== undefined) {
        filteredClients = filteredClients.filter(c => c.bandUsagePercent <= filters.bandUsageMax!);
      }

      return of(filteredClients).pipe(delay(500));
    }

    // Futuro: API real
    return this.apiService.get<ClientMonitoring[]>('monitoring/clients', {}, filters);
  }

  updateClientStatus(clientId: string, status: string): Observable<void | null> {
    if (this.useMockData) {
      // Mock: simular sucesso
      console.log(`[MOCK] Atualizando cliente ${clientId} para status ${status}`);
      return of(void 0).pipe(delay(300));
    }

    // Futuro: API real
    return this.apiService.put<void>(`monitoring/clients/${clientId}/status`, { status });
  }

  getStatusColumns(): Observable<MonitoringStatusColumn[] | null> {
    if (this.useMockData) {
      return of(MOCK_STATUS_COLUMNS).pipe(delay(200));
    }

    // Futuro: API real
    return this.apiService.get<MonitoringStatusColumn[]>('monitoring/status-columns');
  }
}
